import { ChevronLeft, ChevronRight } from 'lucide-react';
import { todayRome } from '../lib/format';

const MONTH = new Intl.DateTimeFormat('it-IT', { month: 'long', timeZone: 'UTC' });
const FIRST_YEAR = 2023; // primi eventi importati dal sito v1

/** "2026-05" → "2026-04" / "2026-06" */
export function shiftMonth(month: string, delta: number): string {
  const [y, m] = month.split('-').map(Number) as [number, number];
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return d.toISOString().slice(0, 7);
}

/** Primo e ultimo giorno del mese "YYYY-MM". */
export function monthRange(month: string): { from: string; to: string } {
  const last = new Date(Date.UTC(Number(month.slice(0, 4)), Number(month.slice(5, 7)), 0));
  return { from: `${month}-01`, to: last.toISOString().slice(0, 10) };
}

export const monthLabel = (month: string) =>
  `${MONTH.format(new Date(`${month}-15T12:00:00Z`))} ${month.slice(0, 4)}`;

/** Scelta del mese: elenco per anno (dal 2023 all'anno prossimo) con frecce precedente/successivo. */
export function MonthPicker({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (month: string | undefined) => void;
}) {
  const lastYear = Number(todayRome().slice(0, 4)) + 1;
  const years = Array.from({ length: lastYear - FIRST_YEAR + 1 }, (_, i) => lastYear - i);
  const current = todayRome().slice(0, 7);
  const arrow =
    'flex h-9 w-8 items-center justify-center bg-page hover:bg-surface-strong disabled:text-muted';
  return (
    <div className="flex items-center gap-px" role="group" aria-label="Mese">
      <button
        type="button"
        className={arrow}
        onClick={() => onChange(shiftMonth(value ?? current, -1))}
        aria-label="Mese precedente"
      >
        <ChevronLeft className="size-4" aria-hidden />
      </button>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || undefined)}
        aria-label="Mese"
        className={`h-9 px-2 text-sm ${value ? 'bg-fg font-medium text-page' : 'bg-page'}`}
      >
        <option value="">Mese…</option>
        {years.map((y) => (
          <optgroup key={y} label={String(y)}>
            {Array.from({ length: 12 }, (_, i) => `${y}-${String(i + 1).padStart(2, '0')}`).map(
              (m) => (
                <option key={m} value={m}>
                  {monthLabel(m)}
                </option>
              ),
            )}
          </optgroup>
        ))}
      </select>
      <button
        type="button"
        className={arrow}
        onClick={() => onChange(shiftMonth(value ?? current, 1))}
        aria-label="Mese successivo"
      >
        <ChevronRight className="size-4" aria-hidden />
      </button>
    </div>
  );
}
